import axios from "axios";
import { getAccessToken } from "config/token";

export interface DeleteFilesParams {
  region: string;
  bucket: string;
  keys: string[];
  reason: string;
  permanentDelete: boolean;
  domainName: string;
  spaceName: string;
  userEmail:string;
  msalInstance: any;
  spaceType?: string; // GxP flag to determine if space is Non-GxP
}

export interface DeleteFilesAPIResponse {
  success: boolean;
  message: string;
  [key: string]: any;
}

export async function deleteFilesAPI({
  region,
  bucket,
  keys,
  reason,
  permanentDelete,
  domainName,
  spaceName,
  userEmail,
  msalInstance,
  spaceType,
}: DeleteFilesParams): Promise<DeleteFilesAPIResponse> {
  // Get Auth token
  const token = await getAccessToken(msalInstance);
  const bearer = token ? `Bearer ${token.token}` : "";
  // Check if this is a Non-GxP space
  const isNonGxpSpace = spaceType?.toLowerCase() === "nongxp";

  // Determine bucket type
  const bucketType = isNonGxpSpace ? "nongxp" : "gxp";

  // For Non-GxP spaces, don't include reason_for_deletion and harddelete/permanent_delete parameters
  const payload: any = {
    bucket_name: bucket,
    domain_name: domainName,
    region_name: region,  
    selected_prefixes: keys,
    space_name: spaceName,
    loggedInUserEmail: userEmail,
    bucket_type: bucketType,
    harddelete: permanentDelete,
    permanent_delete: permanentDelete,
    reason_for_deletion: isNonGxpSpace ? "" : reason, // Only add reason parameter for GxP spaces
  };

  try {
    const response = await axios.post<DeleteFilesAPIResponse>(
      `${process.env.REACT_APP_NEXUS_API_BASE_URL}/datazone/delete-objects`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": bearer,
        },
      },
    );
    console.log("[deleteFilesAPI] response status:", response.status);
    console.log("[deleteFilesAPI] response data:", response.data);
    return response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      console.error(
        "[deleteFilesAPI] ERROR (Axios):",
        err.response?.status,
        err.response?.data,
        err.message,
        err,
      );
    } else {
      console.error("[deleteFilesAPI] ERROR (Non-Axios):", err);
    }
    throw err;
  }
}
